import store from '@/store'
import { QcqCommonGridItem, UiLanguageItem, UiLanguageList } from '@/types'
import { SpecializationResponse, SpecializationResponseItem } from '@/types/service-response'

export interface SpecializationItem {
  id: number
  code: string
  description: string
}

export class Specialization {
  private constructor (
    readonly dataMap: Map<string, SpecializationItem>
  ) {}

  get commonGridData (): QcqCommonGridItem {
    const selectedUiLanguage: UiLanguageItem | undefined = store.state.selectedUiLanguage
    const value = this.dataMap.get(selectedUiLanguage!.code)
    const newItem: QcqCommonGridItem = {
      id: value!.id,
      code: value!.code,
      description: value!.description,
    }
    return newItem!
  }

  // @ts-ignore
  static createListFromResponse (responseData: SpecializationResponse): Array<Specialization> {
    const specializationlist: Array<Specialization> = []
    let result: Map<number, Array<SpecializationResponseItem>> = new Map()
    const languageList: UiLanguageList = store.state.uiLanguageList

    responseData.forEach((responseItem: SpecializationResponseItem) => {
      if (responseItem.SpracheID !== null) {
        if (!result.has(responseItem.FachrichtungenID)) {
          result.set(responseItem.FachrichtungenID, [responseItem])
        } else {
          result.get(responseItem.FachrichtungenID)!.push(responseItem)
        }
      }
    })

    result.forEach((responseItemArray: Array<SpecializationResponseItem>) => {
      let dataMap: Map<string, SpecializationItem> = new Map()
      responseItemArray.forEach((responseItem: SpecializationResponseItem) => {
        const languageItem = languageList.find((languageItem: UiLanguageItem) => languageItem.syzId === responseItem.SpracheID)
        if (languageItem) {
          let row: SpecializationItem = {
            id: responseItem.FachrichtungenID,
            code: responseItem.FachrichtungenCode,
            description: responseItem.FachrichtungenBezeichnung
          }
          dataMap.set(languageItem.code, row)
        }
      })
      specializationlist.push(new Specialization(dataMap))
    })
    return specializationlist
  }
}